import state from './entities-state';
import mutations from './entities-mutations';
import actions from './entities-actions';
import getters from './entities-getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
